import { useState } from 'react';
import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

interface AdminShellProps {
  children: ReactNode;
}

/** Persistent dashboard frame: sidebar + topbar + scrollable content area. */
export function AdminShell({ children }: AdminShellProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="min-h-full bg-surface-muted">
      <Sidebar isOpen={isSidebarOpen} onNavigate={() => setIsSidebarOpen(false)} />
      <div className="lg:pl-64">
        <Topbar onMenuToggle={() => setIsSidebarOpen((open) => !open)} />
        <main className="mx-auto w-full max-w-8xl px-4 py-6 lg:px-8">{children}</main>
      </div>
    </div>
  );
}
